import { useIsMutating } from '@tanstack/react-query';
import { Row } from '@tanstack/react-table';

import useFetchSystemTemplates from 'components/domain/automation/systemTemplates/useFetchSystemTemplates';
import { TOGGLE_SYSTEM_TEMPLATES_MUTATION_KEY } from 'components/domain/automation/systemTemplates/useToggleSystemTemplatesMutation';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import Switch from 'components/switch/Switch';
import { SystemTemplateRow } from 'pages/automations/systemTemplates/SystemTemplatesTab.types';
import useStatusCellToggle from './useStatusCellToggle';

interface StateCellProps {
  getValue: () => SystemTemplateRow['defaultStatus'];
  row: Row<SystemTemplateRow>;
}

const StatusCell = ({ getValue, row }: StateCellProps) => {
  const defaultStatus = getValue();
  const { key } = row.original;
  const hasStatus = defaultStatus !== undefined;
  const { data: systemTemplates, isLoading } = useFetchSystemTemplates({
    enabled: hasStatus,
  });

  const toggleSystemTemplatesCount = useIsMutating({
    mutationKey: [TOGGLE_SYSTEM_TEMPLATES_MUTATION_KEY],
  });

  const { onChange } = useStatusCellToggle({ key });

  if (!hasStatus) {
    return null;
  }

  if (isLoading) {
    return <LoadingPlaceholder width="31px" />;
  }

  const systemTemplate = systemTemplates?.find((t) => t.key === key);
  const checked = systemTemplate ? !!systemTemplate.enabled : defaultStatus;

  return (
    <Switch
      checked={checked}
      className="small"
      disabled={toggleSystemTemplatesCount > 0}
      onChange={onChange}
    />
  );
};

export default StatusCell;
